<template>
  <div class="m-home">
    <div class="m-menus" @click="visibleMenus = true">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <slide-out size="50%" :visible="visibleMenus" :showClose="true" @closed="visibleMenus = false">
      <div class="m-menu-name">
        <img
          class="m-img m-close-menus"
          src="@/assets/wap/close-menus.png"
          @click="visibleMenus = false"
        />
        <div v-for="(menu, index) in menus" :key="index" @click="menu.gotoNext()">{{menu.name}}</div>
      </div>
    </slide-out>

    <img class="m-img m-background" src="@/assets/wap/background-top.jpg" />
    <div class="m-index-middle">
      <img class="m-img m-background" src="@/assets/wap/background-middle.jpg" />

      <div class="m-content">
        <img class="m-middle-logo" src="@/assets/wap/logo.png" />
        <p
          class="m-description"
        >湖南创新娱乐传媒有限公司是湖南广播电视台娱乐频道一体化运行公司，依托于湖南广播影视集团·大芒果生态，布局综艺节目、大型活动、广告营销、内容制作、新媒体矩阵、短视频运营等全领域生态产品，创新媒体运营模式，放大品牌传播价值，致力打造具有社会责任感和社会影响力的整合媒体和内容服务机构。</p>
      </div>
    </div>

    <div class="m-index-bottom">
      <img class="m-img m-background" src="@/assets/wap/background-bottom.jpg" />
      <div class="m-action">
        <img :src="prevArrow" @click="switchVideoFromArrows('prev')" />
        <img :src="nextArrow" @click="switchVideoFromArrows('next')" />
      </div>
      <dplayer ref="player" class="m-video-item" :options="videoOptions"></dplayer>
      <!-- <div class="m-title">
        <div class="m-number">{{videoTitle.number}}</div>
        <div class="m-name">{{videoTitle.name}}</div>
      </div>-->

      <div class="m-pagination">
        <div
          v-for="(soucre, index) in videosSources"
          :key="index"
          class="m-hots"
          :class="{'m-active': currentIndex === index }"
          @click="switchVideoFromHots(index)"
        ></div>
      </div>
    </div>

    <div id="m-footer" class="m-footer">
      <div class="m-join-us">
        <p class="m-top">
          <img class="m-symbol begin" src="@/assets/symbol-begin.png" />
          <span class="m-title">加入我们</span>
          <span class="m-cutting-line"></span>
        </p>
        <p class="m-bottom">
          <span class="m-content">有梦当燃，向阳而造，期待志同道合的你</span>
          <img class="m-symbol end" src="@/assets/symbol-end.png" />
        </p>
      </div>

      <div class="m-contact-us">
        <div class="m-telephone">
          <p class="m-top">
            <img class="m-img m-icon-phone" src="@/assets/telephone-icon.png" />
            <span class="m-text">电话</span>
            <span class="m-shallow">/ telephone</span>
          </p>
          <p class="m-bottom">0731-84802287</p>
        </div>

        <div class="m-contact-us-middle">
          <p class="m-top">
            <img class="m-img m-icon-mail" src="@/assets/mail-icon.png" />
            <span class="m-text">邮箱</span>
            <span class="m-shallow">/ mailbox</span>
          </p>
          <p class="m-bottom">mango@fulantv.com</p>
        </div>

        <div class="m-address">
          <p class="m-top">
            <img class="m-img m-icon-location" src="@/assets/address-icon.png" />
            <span class="m-text">地址</span>
            <span class="m-shallow">/ address</span>
          </p>
          <p class="m-bottom">湖南省长沙市开福区湖南电视台</p>
        </div>
      </div>

      <div class="m-archive">
        <img class="m-img m-ghs" src="@/assets/ghs-icon.png" />
        <a href="http://www.beian.miit.gov.cn" target="_blank">湘ICP备20009389号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
import VueDPlayer from "vue-dplayer";
import SlideOut from "@hyjiacan/vue-slideout";
import "vue-dplayer/dist/vue-dplayer.css";
import "@hyjiacan/vue-slideout/lib/slideout.css";

export default {
  name: "home",
  components: {
    SlideOut,
    dplayer: VueDPlayer,
  },
  data() {
    return {
      menus: [
        {
          name: "首页",
          gotoNext: () => {
            this.$router.push({ name: "wap" });
            this.visibleMenus = false;
          },
        },
        {
          name: "会员中心",
          gotoNext: () => {
            window.open(
              "https://mp.fulantv.com/index.html#/login",
              "about:blank"
            );
            this.visibleMenus = false;
          },
        },
        {
          name: "商务合作",
          gotoNext: () => {
            window.location.hash = "#m-footer";
            this.visibleMenus = false;
          },
        },
      ],
      visibleMenus: false,
      currentIndex: 0,
      prevArrow: require("@/assets/arrow-prev.png"),
      nextArrow: require("@/assets/arrow-next.png"),
      videosSources: [
        {
          src: "http://webcdn.fulantv.com/website/video/launch_vcr.mp4",
          poster: require("@/assets/wap/poster-1.jpg"),
          title: {
            number: "01",
            name: "创新娱乐启动仪式",
          },
        },
        {
          src: "http://webcdn.fulantv.com/website/video/mango_league.mp4",
          poster: require("@/assets/wap/poster-2.jpg"),
          title: {
            number: "02",
            name: "创新娱乐启动仪式2",
          },
        },
        {
          src: "http://webcdn.fulantv.com/website/video/environment.mp4",
          poster: require("@/assets/wap/poster-3.jpg"),
          title: {
            number: "03",
            name: "创新娱乐启动仪式3",
          },
        },
        {
          src: "http://webcdn.fulantv.com/website/video/480art_studio.mp4",
          poster: require("@/assets/wap/poster-4.jpg"),
          title: {
            number: "04",
            name: "创新娱乐启动仪式4",
          },
        },
      ],
      videoOptions: {
        preload: "auto",
        controller: false,
        logo: require("@/assets/play-btn.png"),
        video: {
          url: "http://webcdn.fulantv.com/website/video/launch_vcr.mp4",
          pic: require("@/assets/wap/poster-1.jpg"),
        },
      },
    };
  },

  computed: {
    videoTitle() {
      return this.videosSources[this.currentIndex].title;
    },
  },

  mounted() {
    let vm = this;
    const player = vm.$refs.player.dp;
    if (player) {
      var playerDom = document.querySelector(".m-video-item");
      var logo = document.querySelector(".dplayer-logo");
      var mask = document.querySelector(".dplayer-controller-mask");

      if (this.isMobile()) {
        playerDom.addEventListener("click", function () {
          player.toggle();
        });
      }

      player.on("play", function () {
        logo.style.display = "none";
        mask.style.display = "none";
      });
      player.on("pause", function () {
        logo.style.display = "block";
        mask.style.display = "block";
      });
    }
  },

  methods: {
    switchVideoFromArrows(type) {
      if (type === "prev") {
        if (this.currentIndex > 0) {
          this.currentIndex -= 1;
        } else {
          this.currentIndex = this.videosSources.length - 1;
        }
        this.prevArrow = require("@/assets/arrow-prev-light.png");
      } else {
        if (this.currentIndex < this.videosSources.length - 1) {
          this.currentIndex += 1;
        } else {
          this.currentIndex = 0;
        }
        this.nextArrow = require("@/assets/arrow-next-light.png");
      }
      setTimeout(() => {
        this.prevArrow = require("@/assets/arrow-prev.png");
        this.nextArrow = require("@/assets/arrow-next.png");
      }, 300);
      this.switchVideoFromHots(this.currentIndex);
    },

    switchVideoFromHots(index) {
      var logo = document.querySelector(".dplayer-logo");
      var mask = document.querySelector(".dplayer-controller-mask");
      const player = this.$refs.player.dp;
      this.currentIndex = index;
      player.switchVideo({
        url: this.videosSources[index].src,
        pic: this.videosSources[index].poster,
      });
      logo.style.display = "block";
      mask.style.display = "block";
    },
  },
};
</script>
<style lang="scss">
$vw_design: 750;
@function vw($px) {
  @return $px/($vw_design/100) + vw;
}

.m-home {
  .m-img {
    width: 100%;
    height: 100%;
  }

  .m-menus {
    width: vw(62);
    position: fixed;
    top: vw(33);
    right: vw(36);
    z-index: 1;
    background: rgba(245, 143, 32, 0.7);
    border-radius: 6px;
    padding: vw(13) vw(6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    div {
      width: 100%;
      height: vw(8);
      background: #fff;
      border-radius: vw(6);
      margin-bottom: vw(8);
    }

    div:last-child {
      margin-bottom: 0;
    }
  }

  .m-menu-name {
    font-size: vw(36);
    display: flex;
    flex-direction: column;

    .m-close-menus {
      width: vw(38);
      height: vw(38);
      margin: vw(33) vw(32);
      align-self: flex-end;
    }

    div {
      height: vw(100);
      line-height: vw(100);
      border-bottom: 1px solid #ccc;
      margin: 0 vw(44) 0;

      a {
        color: #2c3e50;
      }
    }
  }

  .m-index-middle {
    height: vw(826);
    position: relative;

    .m-content {
      padding: 0 vw(33) 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      margin: 0 auto;
      left: 0;
      right: 0;

      .m-middle-logo {
        width: vw(484);
        height: vw(54);
      }

      .m-description {
        font-size: vw(28);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: justify;
        text-align-last: center;
        line-height: vw(60);
      }
    }
  }

  .m-index-bottom {
    height: vw(726);
    position: relative;

    .m-action {
      position: absolute;
      top: vw(82);
      left: vw(32);

      img:first-child {
        margin-right: vw(15);
      }

      img {
        width: vw(59);
        height: vw(59);
      }
    }

    .m-video-item {
      position: absolute;
      margin: 0 vw(47) 0 vw(29);
      top: vw(171);
      height: vw(379);

      .dplayer-video-wrap > .dplayer-logo {
        position: absolute !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        left: 0 !important;
        right: 0 !important;
        margin: 0 auto !important;
        z-index: 1;
        max-width: vw(95);
        max-height: vw(95);

        img {
          width: vw(95);
          height: vw(95);
        }
      }

      .dplayer-controller-mask {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: auto;
        background: rgba(0, 0, 0, 0.5);
        transition: none;
      }

      .dplayer-controller {
        display: none;
      }
    }

    .m-pagination {
      position: absolute;
      bottom: vw(35);
      left: 0;
      right: 0;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      .m-hots {
        width: vw(18);
        height: vw(18);
        background: rgba(255, 255, 255, 1);
        opacity: 0.2;
        border-radius: 50%;
        margin-right: vw(14);
      }

      .m-active {
        opacity: 1;
      }
    }
  }

  .m-footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 vw(27);
    font-family: PingFang-SC-Regular;

    p {
      margin: 0;
    }

    img {
      width: auto;
    }

    .m-join-us {
      display: flex;
      flex-direction: column;
      font-size: vw(30);
      padding: vw(146) 0 vw(79);

      .m-top {
        align-self: flex-start;
        margin-bottom: vw(35);

        .m-symbol {
          width: vw(28);
          height: vw(28);
        }

        .begin {
          margin: 0 vw(19) vw(12) 0;
        }
      }

      .m-bottom {
        display: flex;
        font-size: vw(34);
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #ffb129;
        margin-left: vw(42);

        .m-symbol {
          width: vw(28);
          height: vw(28);
        }

        .end {
          margin: vw(22) 0 0 vw(12);
        }
      }
    }

    .m-contact-us {
      text-align: left;

      img {
        width: vw(32);
        margin-right: vw(13);
      }

      .m-top {
        display: flex;
        align-items: center;
      }

      .m-top .m-text {
        font-size: vw(32);
        font-weight: bold;
      }

      .m-top .m-shallow {
        font-size: vw(24);
      }

      .m-telephone .m-bottom,
      .m-address .m-bottom {
        margin: vw(8) 0 0 vw(45);
        font-size: vw(30);
      }

      .m-icon-phone {
        width: vw(32);
        height: vw(28);
      }

      .m-icon-mail {
        width: vw(32);
        height: vw(22);
      }

      .m-icon-location {
        width: vw(24);
        height: vw(30);
      }

      .m-contact-us-middle {
        margin: vw(52) 0;
        font-size: vw(30);

        .m-bottom {
          margin: vw(8) 0 0 vw(45);
        }
      }
    }

    .m-archive {
      padding: vw(87) 0 vw(158);
      display: flex;
      align-items: center;

      .m-ghs {
        width: vw(30);
        height: vw(30);
        margin-right: vw(17);
      }

      a {
        font-size: vw(24);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: #666;
        outline: 0;
        text-decoration: none;
      }
    }
  }
}
</style>
